import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import Select from 'react-select-plus';
import Toggle from 'react-toggle';
import {
  ModalTrigger,
  Pagination,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel,
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper,
} from 'modules/theme';
import {
  ModalForm,
  ModalFormContainer,
} from '../../../../theme/theme1/common/styles/main';

class SmppProviderAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `SMS Smpp`;
    this.moduleUrl = `setting/sms-provider`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
  }
  setData(editData = '') {
    editData = editData || {};
    this.state = {
      name: editData.name || '',
      host: editData.host || '',
      port: editData.port || '',
      systemId: editData.systemId || '',
      prefix: editData.prefix || '',
      password: '',
      version: editData.version || '',
      secure: editData.secure || false,
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  handleSelect(selectedOption, name) {
    this.setState({ [name]: selectedOption ? selectedOption.value : null });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      Alert.success(`${data.message}`);
      this.setData();
      this.props.closeModal(true);
    } else {
      Alert.error(`${data.message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
	if (!(this.state.name.trim() && this.state.host.trim() && this.state.systemId.trim() )) return Alert.error('Please enter required data');
    let tData = {
      name: this.state.name.trim(),
      host: this.state.host.trim(),
      port: parseInt(this.state.port) || 2775, // 8775
      systemId: this.state.systemId.trim(),
      password: this.state.password,
      prefix: this.state.prefix || '',
      secure: this.state.secure,
      version: this.state.version,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.setData();
            _this.props.closeModal(true);
            Alert.success('SMPP Provider updated successfully');
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
		  Alert.success('SMPP Provider created successfully');
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('name', {
                placeholder: 'Name',
                defaultValue: '',
                autoFocus: true,
                required: true,
                id: 'name',
                maxLength: 25,
                value: this.state.name,
                onChange: (e) => {
                  this.setState({ name: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('prefix', {
                placeholder: 'Prefix',
                defaultValue: '',
                autoFocus: false,
                required: false,
                id: 'prefix',
                value: this.state.prefix,
                onChange: (e) => {
                  this.setState({ prefix: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('host', {
                placeholder: 'Host',
                defaultValue: '',
				maxLength: 250,
                autoFocus: false,
                required: true,
                id: 'host',
                value: this.state.host,
                onChange: (e) => {
                  this.setState({ host: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('port', {
                placeholder: 'Port',
                defaultValue: '',
                autoFocus: false,
                required: true,
                id: 'port',
                type: 'number',
                value: this.state.port,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  if (e.target.value < 0 || e.target.value > 65536) {
                    // let agentName = e.target.value && e.target.value.trim() == "" ? "" : e.target.value;
                    // this.setState({ port: agentName });
                    Alert.error(`Port number must be between 0 to 65536`);
                    return;
                  }
                  let agentName =
                    e.target.value && e.target.value.trim() == ""
                      ? ""
                      : e.target.value;
                  this.setState({ port: agentName });
                },
                onKeyDown: (e) => {
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                },              
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('User ID / system ID', {
                placeholder: 'User ID / System ID',
                defaultValue: '',
                autoFocus: false,
                required: true,
                id: 'systemId',
                maxLength: 25,
                value: this.state.systemId,
                onChange: (e) => {
                  this.setState({ systemId: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('password', {
                placeholder: 'Password',
                defaultValue: '',
                autoFocus: false,
                required: true,
                id: 'password',
                type: 'password',
                value: this.state.password,
                onChange: (e) => {
                  this.setState({ password: e.target.value });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormGroup>
              <ControlLabel>Secure</ControlLabel>
              <FormColumn>
                <Toggle
                  defaultChecked={this.state.secure}
                  icons={{
                    checked: <span>Yes</span>,
                    unchecked: <span>No</span>,
                  }}
                  onChange={(e) => {
                    this.setState({ secure: e.target.checked });
                  }}
                  name='secure'
                  id='secure'
                  value={this.state.secure}
                />
              </FormColumn>
            </FormGroup>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            onClick={() => this.props.closeModal()}
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme type='blueModalBtn' btnType='submit'>
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </ModalForm>
    );
  }
}

SmppProviderAddEdit.propTypes = {
  group: PropTypes.array,
};

SmppProviderAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default SmppProviderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmppProvider/components/SmppProviderAddEdit.js